module.exports = __webpack_public_path__ + "static/media/bin.1308c217.png";